import { render } from "./offer.offerLeadBank.vue?vue&type=template&id=70a16d49"
import script from "./offer.offerLeadBank.vue?vue&type=script&lang=js"
export * from "./offer.offerLeadBank.vue?vue&type=script&lang=js"

import "./offer.offerLeadBank.vue?vue&type=style&index=0&id=70a16d49&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__